import React, { useState } from "react";
import { Plus, Trash2, Pin } from "lucide-react";
import NoteDialog from "../Notes/NoteDialog";

const DashboardGeneralNotes = ({
  groupedNotes,
  softBlue,
  cardBg,
  addNote,
  updateNote,
  deleteNote,
  workspaceId,
  onNoteChanged
}) => {
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    noteDate: new Date().toISOString().split("T")[0],
    category: "",
    isGeneral: true,
  });

  const handleOpenAdd = (category = "") => {
    setFormData({
      title: "",
      content: "",
      noteDate: new Date().toISOString().split("T")[0],
      category: category || "Allgemein",
      isGeneral: true,
    });
    setIsEditing(false);
    setShowModal(true);
  };

  const handleOpenEdit = (note) => {
    setFormData({ ...note });
    setIsEditing(true);
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      const payload = {
        ...formData,
        workspaceId: String(workspaceId) // Stringified to match your Zod schema
      };
      if (isEditing) {
        await updateNote(formData.id, payload);
      } else {
        await addNote(payload);
      }
      setShowModal(false);
      if (onNoteChanged) await onNoteChanged();
    } catch (err) {
      console.error("Save failed:", err);
    }
  };

  const handleDelete = async (e, note) => {
    e.stopPropagation(); // Prevent opening edit modal
    if (window.confirm(`Notiz "${note.title}" löschen?`)) {
      await deleteNote(note.id);
      if (onNoteChanged) await onNoteChanged();
    }
  };

  return (
    <div className="rounded-4 border-0 mb-2 p-2 d-flex flex-column flex-md-row bg-white shadow-sm border-start border-primary border-4">
      {/* Sidebar Label - Hidden on mobile */}
      <div className="d-none d-md-flex align-items-center justify-content-center px-2"
        style={{ writingMode: "vertical-rl", transform: "rotate(180deg)", color: "#94a3b8", fontWeight: 700, fontSize: "0.65rem", letterSpacing: "1px" }}>
        PINNED
      </div>

      {/* Mobile Label */}
      <div className="d-md-none fw-bold text-muted mb-2 px-2 border-bottom pb-1" style={{ fontSize: '0.65rem' }}>PINNED NOTES</div>

      <div className="d-flex flex-grow-1 gap-3 flex-wrap align-items-start ps-md-2">
        {Object.keys(groupedNotes).length === 0 ? (
          <button className="btn btn-sm text-muted border-dashed m-2" onClick={() => handleOpenAdd()}>
            <Plus size={14} /> Notiz anheften
          </button>
        ) : (
          Object.entries(groupedNotes)
            .sort(([a], [b]) => a.localeCompare(b, 'de'))
            .map(([category, items]) => (
              <div key={category} style={{ minWidth: "160px", flex: "1 1 auto", maxWidth: "300px" }}>
                <h6 className="fw-bold mb-1 d-flex justify-content-between align-items-center text-muted text-uppercase" style={{ fontSize: '0.65rem' }}>
                  {category}
                  <button className="btn btn-link p-0" onClick={() => handleOpenAdd(category)}><Plus size={12} /></button>
                </h6>
                <div className="d-flex flex-column gap-1">
                  {items.map((note) => (
                    <div key={note.id} className="px-2 py-1 rounded-2 d-flex align-items-center justify-content-between note-row" onClick={() => handleOpenEdit(note)}>
                      <div className="d-flex align-items-center text-truncate pe-2">
                        <Pin size={10} className="me-2 text-warning" />
                        <span className="text-truncate" style={{ fontSize: "0.75rem" }}>{note.title}</span>
                      </div>
                      <Trash2 size={11} className="text-danger action-btns opacity-0" onClick={(e) => handleDelete(e, note)} />
                    </div>
                  ))}
                </div>
              </div>
            ))
        )}
      </div>

      <NoteDialog
        show={showModal}
        isEditing={isEditing}
        formData={formData}
        setFormData={setFormData}
        onSave={handleSave}
        onClose={() => setShowModal(false)}
      />

      <style>{`
        .note-row:hover { background-color: #f8fafc; border-color: #e2e8f0 !important; }
        .note-row:hover .action-btns { opacity: 1 !important; }
        .hover-opacity-100:hover { opacity: 1 !important; }
        .hover-danger:hover { opacity: 1 !important; }
        .transition-all { transition: all 0.2s ease; }
      `}</style>
    </div>
  );
};

export default DashboardGeneralNotes;